import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';

import CustomLayout from './pages/Layout';
import Homepage from './pages/Homepage';

import { IsFormSaved } from './context/FromStatusContext';

import './global.css';
import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import auth from './services/auth.services';
import { jwtDecode } from 'jwt-decode';
import { login, login_fail } from './actions/login.action.js';
import { useDispatch } from 'react-redux';

function App() {
  const [isFormSaved, setIsFormSaved] = useState(true);

  const [isDarkMode, setIsDarkMode] = useState(false);
  const { defaultAlgorithm, darkAlgorithm } = theme;
  const handleClick = () => setIsDarkMode((previousValue) => !previousValue);

  const dispatch = useDispatch();

  useEffect(() => {
    const token = auth.retriveToken();
    if (token) {
      const decoded_token = jwtDecode(token);
      dispatch(login(decoded_token));
    } else {
      dispatch(login_fail());
    }
  }, [auth.retriveUserInfo]);

  return (
    <IsFormSaved.Provider value={{ isFormSaved, setIsFormSaved }}>
      <ConfigProvider
        theme={{
          algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm,
          token: {
            colorPrimary: '#5a5ab5',
            colorTextSecondary: '#812990',
            colorError: '#ff8399',
            colorWarning: '#f6941c',
            fontFamily: '"Roboto Slab", serif'
          },
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route exact path="/" element={<Homepage />} />
            <Route
              exact
              path="/home"
              element={
                <CustomLayout
                  isDarkMode={isDarkMode}
                  handleTheme={handleClick}
                />
              }
            />
            <Route
              exact
              path="/profile"
              element={
                <CustomLayout
                  isDarkMode={isDarkMode}
                  handleTheme={handleClick}
                />
              }
            />
            <Route
              path="/:status/:formNo"
              element={
                <CustomLayout
                  isDarkMode={isDarkMode}
                  handleTheme={handleClick}
                />
              }
            />
            <Route
              exact
              path="/results"
              element={
                <CustomLayout
                  isDarkMode={isDarkMode}
                  handleTheme={handleClick}
                />
              }
            />
            <Route
              exact
              path="/submit-publications-data"
              element={
                <CustomLayout
                  isDarkMode={isDarkMode}
                  handleTheme={handleClick}
                />
              }
            />
            <Route
              path="/faculty-results"
              element={
                <ProtectedRoute allowedRoles={['dean', 'admin', 'vc', 'hod']}>
                  <CustomLayout
                    isDarkMode={isDarkMode}
                    handleTheme={handleClick}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/faculties"
              element={
                <ProtectedRoute allowedRoles={['dean', 'admin', 'vc', 'hod']}>
                  <CustomLayout
                    isDarkMode={isDarkMode}
                    handleTheme={handleClick}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/faculty/:id"
              element={
                <ProtectedRoute allowedRoles={['dean', 'admin', 'vc', 'hod']}>
                  <CustomLayout
                    isDarkMode={isDarkMode}
                    handleTheme={handleClick}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/faculty/:id/planning/:formID"
              element={
                <ProtectedRoute allowedRoles={['dean', 'admin', 'vc', 'hod']}>
                  <CustomLayout
                    isDarkMode={isDarkMode}
                    handleTheme={handleClick}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/faculty/:id/evaluation/:formID"
              element={
                <ProtectedRoute allowedRoles={['dean', 'admin', 'vc', 'hod']}>
                  <CustomLayout
                    isDarkMode={isDarkMode}
                    handleTheme={handleClick}
                  />
                </ProtectedRoute>
              }
            />

          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </IsFormSaved.Provider>
  );
}

export default App;
